import { useQuery } from "@tanstack/react-query";
import { ArrowLink, Container } from "@/components/shared/PageHeader";
import { Reveal } from "@/components/shared/Reveal";
import { EventCard } from "@/components/shared/EventCard";
import { fetchEvents } from "@/lib/api";

/** The next three things on the programme, apart from the one you are reading about. */
export const RelatedEvents = ({ currentId }) => {
  const { data } = useQuery({ queryKey: ["events-all"], queryFn: () => fetchEvents({ limit: 100 }) });
  const items = (data || []).filter((e) => e.id !== currentId).slice(0, 3);
  if (!items.length) return null;
  return (
    <section className="border-t border-border py-16 sm:py-20" data-testid="event-related" aria-labelledby="related-title">
      <Container><Reveal>
        <div className="flex flex-wrap items-end justify-between gap-x-8 gap-y-4">
          <div>
            <p className="t-mono text-muted-foreground">Fleire arrangement</p>
            <h2 id="related-title" className="t-h2 mt-3 text-balance">Meir som skjer på huset</h2>
          </div>
          <ArrowLink to="/arrangement" data-testid="event-related-all-link">Heile programmet</ArrowLink>
        </div>
        <div className="mt-10 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-testid="event-related-grid">
          {items.map((e) => <EventCard key={e.id} event={e} />)}
        </div>
      </Reveal></Container>
    </section>
  );
};
